import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { reactOnCms } from 'common/js/react_on_cms';
import { getSeaLinkBasename } from 'utils/helpers';
import AbandonCartModal from 'components/abandon_cart_modal';
import CrmTracking from 'components/crm_tracking';
import store from 'redux/store';
import HeaderIcons from 'tenants/sealink/header_icons';
import NavigationBar from 'tenants/sealink/navigation_bar';
import UserNavigationButtons from 'tenants/sealink/navigation_mobile';
import MobileSearch from 'tenants/sealink/navigation_mobile/mobile_search';
import TenantSwitchWarning from 'tenants/sealink/tenant_switch_warning';

reactOnCms.register({
  HeaderIcons,
  MobileSearch,
  UserNavigationButtons,
  NavigationBar,
  TenantSwitchWarning,
  CrmTracking,
  AbandonCartModal,
});

const basename = getSeaLinkBasename();
reactOnCms.addWrapper({
  reactElement: BrowserRouter,
  reactProps: { basename },
});
// Wrap content with Redux Provider
reactOnCms.addWrapper({
  reactElement: Provider,
  reactProps: { store },
});
